import {
  Box,
  Flex,
  FlexProps,
  HStack,
  IconButton,
  Skeleton,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';
import { FiMenu } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';

import Transitions from '../../components/Transitions';
import { DeadlineSearchResultResults } from '../../models/gen/deadlineSearchResultResults';

type WireframeProps = PropsWithChildren<{
  title: string;
  guarding?: boolean;
  backdropMessage?: string;
  topMessages?: Array<DeadlineSearchResultResults>;
  isLoaded?: boolean;
}>;

const Wireframe: React.FunctionComponent<WireframeProps> = ({
  title,
  children,
  topMessages = [],
  isLoaded = true,
  /* eslint-disable @typescript-eslint/no-unused-vars */
  guarding,
  backdropMessage,
  /* eslint-enable @typescript-eslint/no-unused-vars */
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      className="wireframe"
      h="100%"
      w="full"
      maxWidth="100%"
      bg={useColorModeValue('gray.100', 'gray.900')}
    >
      <MobileNav className="mobile-nav" onOpen={onOpen} title={title} />
      <Transitions>
        <HStack
          // ml={{ base: 0, md: 60 }}
          p={{ base: 2, md: 4 }}
          h={{ base: 'calc(95% - 12 - 16px)', md: 'calc(95% - 20 - 16px)' }}
          justifyContent="center"
          overflow="auto"
          className="main-area"
          width="full"
        >
          <Skeleton
            as={HStack}
            justifyContent="center"
            isLoaded={isLoaded}
            width="100%"
          >
            {children}
          </Skeleton>
        </HStack>
      </Transitions>
    </Box>
  );
};

interface MobileProps extends FlexProps {
  onOpen: () => void;
  title: string;
}
const MobileNav: React.FunctionComponent<MobileProps> = ({
  onOpen,
  title,
  ...rest
}) => {
  const location = useLocation();
  console.debug(`${location.pathname}${location.search}`);

  return (
    <Flex
      // ml={{ base: 0, md: 60 }}
      px={{ base: 0, md: 4 }}
      h={{ base: 12, md: 20 }}
      alignItems="center"
      bg={useColorModeValue('white', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      // justifyContent={{ base: 'space-between', md: 'flex-end' }}
      justifyContent={{ base: 'center' }}
      pos="sticky"
      top={0}
      zIndex={100}
      {...rest}
    >
      {/* <HStack display={{ base: 'flex' }} visibility={{ md: 'hidden' }}>
        <IconButton
          onClick={onOpen}
          variant="outline"
          aria-label="open menu"
          icon={<FiMenu />}
        />
      </HStack> */}

      <Text
        // display={{ base: 'flex', md: 'none' }}
        display={{ base: 'flex' }}
        fontSize="2xl"
        // fontFamily="monospace"
        fontWeight="bold"
      >
        {/* Logo */}
        {title}
      </Text>

      {/* <HStack spacing={{ base: '0', md: '6' }}>
        <IconButton
          size="lg"
          variant="ghost"
          aria-label="open menu"
          icon={<FiBell />}
        />
        <Flex alignItems={'center'}></Flex>
      </HStack> */}
    </Flex>
  );
};

export default Wireframe;
